
const id = {
    INVALID_ACTION: 'Aksi ini tidak dapat dilakukan',
    INVALID_USERNAME: 'Username tidak valid',
    TOO_LONG_OR_SHORT_PASSWORD: 'Password terlalu pendek',
    INVALID_EMAIL: 'Email tidak valid',
    INVALID_FIRST_NAME: 'Nama depan diperlukan',
    INVALID_LAST_NAME: 'Nama belakang diperlukan',
    THIS_PROFILE_IS_BEING_USED: 'Profil ini sedang digunakan, tidak dapat dihapus.',
    YOUR_ACCOUNT_IS_LOCKED: 'Akun anda dikunci, anda tidak dapat melakukan apapun.',
    INVALID_ACTION_TO_DELETE: 'Tidak dapat menghapus user ini.',
    RESET_PASSWORD_HAS_BEEN_SENT_3_TIMES: 'Reset password sudah dikirim lebih dari 3 kali. Anda bisa mengirimnya lagi 24 jam ke depan.',
    PASSWORD_CHANGED: 'Kata sandi telah diubah dengan sukses. Sekarang anda dapat login menggunakan password baru.',
    INVALID_LINK: 'Tautan reset password ini tidak valid.',
    'Invalid value': 'Value is not valid',
    OLD_PASSWORD_DOESNT_MATCH: 'Password lama tidak sama',
    NEW_PASSWORD_ISNOT_STANDARD: 'Password baru tidak memenuhi standard',
};
const en = {
    INVALID_ACTION: 'This action is forbidden by system.',
    INVALID_USERNAME: 'Username is not valid',
    TOO_LONG_OR_SHORT_PASSWORD: 'Password is too short, require minimum of 5 character.',
    INVALID_EMAIL: 'Email is not valid',
    INVALID_FIRST_NAME: 'First name is required',
    INVALID_LAST_NAME: 'Last name is required',
    THIS_PROFILE_IS_BEING_USED: 'The profile is being used, cannot be deleted.',
    YOUR_ACCOUNT_IS_LOCKED: 'You account is locked, you can\'t access the app.',
    INVALID_ACTION_TO_DELETE: 'Invalid action to delete this user',
    RESET_PASSWORD_HAS_BEEN_SENT_3_TIMES: 'Reset password has been sent three times. You can only resend it in next 24 hrs',
    PASSWORD_CHANGED: 'Password has been changed successfully, now you can login using your new password.',
    INVALID_LINK: 'This link is not a valid url to reset password.',
    'Invalid value': 'Value is not valid',
    OLD_PASSWORD_DOESNT_MATCH: 'Old Password isnot correct',
    NEW_PASSWORD_ISNOT_STANDARD: 'New Password does not meet standard criteria',
};

export default lang => (lang === 'en' ? en : id);
